import { render } from "./WarningText.vue?vue&type=template&id=4402c184&ts=true"
import script from "./WarningText.vue?vue&type=script&lang=ts"
export * from "./WarningText.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__